import { createListenerMiddleware } from "@reduxjs/toolkit";
import { hydrateResourceBookmarks, toggleResourceBookmark } from "./resourceBookmarksSlice";
import { hydrateMentorBookmarks, toggleMentorBookmark } from "./mentorBookmarksSlice";
import { showToast } from "../notifications/notificationsSlice";
import type { AppDispatch, RootState } from "../../app/store";
import {
    postMentorBookmark as postMentorBookmarkApi,
    deleteMentorBookmark as deleteMentorBookmarkApi,
    postResourceBookmark as postResourceBookmarkApi,
    deleteResourceBookmark as deleteResourceBookmarkApi,
} from "../../api";

export const bookmarkListenerMiddleware = createListenerMiddleware();

const startAppListening = bookmarkListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startAppListening({
    actionCreator: toggleResourceBookmark,
    effect: async (action, listenerApi) => {
        const { userId, resourceId } = action.payload;
        const bookmarks = listenerApi.getState().resourceBookmarks.bookmarks;
        const isBookmarked = bookmarks.some((bookmark) => bookmark.resourceId === resourceId);

        try {
            if (isBookmarked) {
                await postResourceBookmarkApi(userId, resourceId);
            } else {
                await deleteResourceBookmarkApi(userId, resourceId);
            }
        } catch (error) {
            console.error("Failed to persist resource bookmark:", error);
            listenerApi.dispatch(
                showToast({
                    message: "Couldn't save bookmark.",
                    severity: "error",
                }),
            );
        }
    },
});

startAppListening({
    actionCreator: hydrateResourceBookmarks.rejected,
    effect: async (_action, listenerApi) => {
        listenerApi.dispatch(
            showToast({
                message: "Couldn't restore resource bookmarks.",
                severity: "error",
            }),
        );
    },
});

startAppListening({
    actionCreator: toggleMentorBookmark,
    effect: async (action, listenerApi) => {
        const { userId, mentorId } = action.payload;
        const bookmarks = listenerApi.getState().mentorBookmarks.bookmarks;
        const isBookmarked = bookmarks.some((bookmark) => bookmark.mentorId === mentorId);

        try {
            if (isBookmarked) {
                await postMentorBookmarkApi(userId, mentorId);
            } else {
                await deleteMentorBookmarkApi(userId, mentorId);
            }
        } catch (error) {
            console.error("Failed to persist mentor bookmark:", error);
            listenerApi.dispatch(
                showToast({
                    message: "Couldn't save bookmark.",
                    severity: "error",
                }),
            );
        }
    },
});

startAppListening({
    actionCreator: hydrateMentorBookmarks.rejected,
    effect: async (_action, listenerApi) => {
        listenerApi.dispatch(
            showToast({
                message: "Couldn't restore mentor bookmarks.",
                severity: "error",
            }),
        );
    },
});
